module.exports = __webpack_public_path__ + "img/s2Model1.478d2490.png";